export { ShowMore, type ShowMoreProps } from './ShowMore';
